import React, { useEffect, useState, useRef } from "react";
import { ComboBox, MultiSelect } from "@progress/kendo-react-dropdowns";

const GetInstedDataDropdown = ({
    name = "",
    data = [],
    value = [],
    onChange,
    textField,
    dataItemKey,
    isMulti = false,
    className = '',
    onInputChange = () => {}
}) => {
    const [selectedOptions, setSelectedOptions] = useState(isMulti ? [] : null);
    const comboBoxRef = useRef(null); // Create ref for ComboBox

    useEffect(() => {
        if (isMulti) {
            // Map value (keys or objects) to actual data items
            const updatedSelected = value
                ?.map(val => {
                    const key = val?.[dataItemKey] ?? val;
                    return data.find(item => item[dataItemKey] === key);
                })
                .filter(Boolean);
            setSelectedOptions(updatedSelected);
        } else {
            const key = value?.[dataItemKey] ?? value;
            const found = data.find(d => d[dataItemKey] === key) || null;
            setSelectedOptions(found);
        }
    }, [data, value, isMulti, dataItemKey]);

    const handleChange = (event) => {
        const selectedValue = event.value;
        setSelectedOptions(selectedValue);
        onChange({
            target: {
                name,
                value: selectedValue || (isMulti ? [] : null),
            },
        });
    };
    

    const handleInputChange = (event) => {
        const inputValue = event.filter?.value || "";
        onInputChange(inputValue);
    };

    // Focus the ComboBox on mount or after updating the value
    useEffect(() => {
        if (comboBoxRef.current) {
            comboBoxRef.current.focus();
        }
    }, []);

    if (isMulti) {
        return (
            <MultiSelect
                ref={comboBoxRef} // Use the ref here
                className={className}
                data={data}
                value={selectedOptions}
                textField={textField}
                dataItemKey={dataItemKey}
                onChange={handleChange}
                onFilterChange={handleInputChange}
                filterable
                // Enable keyboard navigation and dropdown opening with arrow keys
            />
        );
    }

    return (
        <ComboBox
            ref={comboBoxRef} // Use the ref here
            className={className}
            data={data}
            value={selectedOptions}
            textField={textField}
            dataItemKey={dataItemKey}
            onChange={handleChange}
            onInputChange={(e) => onInputChange(e.target.value)}
            filterable
            // Enable keyboard navigation and dropdown opening with arrow keys
        />
    );
};

export default GetInstedDataDropdown;
